import { useSseStore, type SseStatus } from "@/api/sse";
import { fmtAgo } from "@/lib/format";
import { useUrlState } from "@/state/useUrlState";
import { LIVE_DOT } from "./liveDot";

const TEXT: Record<SseStatus, string> = {
  off: "frozen",
  connecting: "connecting",
  open: "live",
  stale: "stale",
};

export function LiveToggle() {
  const { state, setLive } = useUrlState();
  const status = useSseStore((s) => s.status);
  const lastEventAt = useSseStore((s) => s.lastEventAt);
  const changes = useSseStore((s) => s.changes);
  const title = state.live
    ? `SSE ${TEXT[status]}${lastEventAt ? `, last event ${fmtAgo(lastEventAt / 1000)}` : ""}, ${changes} changes (l)`
    : "live updates off (l)";
  return (
    <button
      type="button"
      className={`ctl flex items-center gap-1 ${state.live ? "on" : ""}`}
      aria-pressed={state.live}
      onClick={() => setLive(!state.live)}
      title={title}
    >
      <span className={`inline-block h-2 w-2 rounded-full ${state.live ? LIVE_DOT[status] : LIVE_DOT.off}`} />
      {state.live ? TEXT[status] : "frozen"}
    </button>
  );
}
